<template>
  <div class="container-fluid">
    <vx-card title="Transacciones Irregulares">
      <vs-table
        :data="transactions"
        noDataText="No se encontraron registros"
        stripe pagination max-items="50">
        <div slot="header" class="ml-4 mb-6 flex items-center flex-grow justify-left">

          <div class="ml-10 flex">
            <vs-input label="Fecha inicio" v-model="startDate" type="date" @change="findTransactions"></vs-input>
            <vs-input label="Fecha fin" v-model="endDate" type="date" class="ml-5" @change="findTransactions"></vs-input>
          </div>

          <div class="ml-10 flex-1 text-right">
           <vs-input label="Buscar" placeholder="CID, IID, UID" v-model="queryString" @keyup.enter.native="findTransactions" />
          </div>
        </div>

        <template slot="thead">
          <vs-th>TRX ID</vs-th>
          <vs-th>Monto</vs-th>
          <vs-th>Ordenante STP</vs-th>
          <vs-th>Beneficiario STP</vs-th>
          <vs-th>Beneficiario RG</vs-th>
          <vs-th>Perfil Id</vs-th>
          <vs-th>Status</vs-th>
          <vs-th>F. de operación</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="(t, index) in data" :key="index">
            <vs-td>{{ t.id }}</vs-td>
            <vs-td>{{ t.amount|currency }}</vs-td>
            <vs-td>
              {{ t.payer.name }} <br>
              RFC/CURP: {{t.payer.rfc_curp}} <br>
              <strong>CLABE: {{t.payer.clabe}}</strong>
            </vs-td>
            <vs-td>
              <template v-if="t.beneficiary !== null">
                {{ t.beneficiary.name }} <br>
                RFC/CURP: {{t.beneficiary.rfc}} <br>
                <strong>CLABE: {{t.beneficiary.clabe}}</strong>
              </template>
            </vs-td>
            <vs-td>
              <template v-if="t.rg_beneficiary !== null">
                {{ t.rg_beneficiary.name }} <br>
                RFC: <span :class="{'text-danger': t.payer.rfc_curp !== t.rg_beneficiary.rfc}">{{t.rg_beneficiary.rfc}}</span> <br>
                CURP: <span :class="{'text-danger': t.payer.rfc_curp !== t.rg_beneficiary.curp}">{{t.rg_beneficiary.curp}} </span> <br>
                <strong>CLABE: {{t.rg_beneficiary.clabe}}</strong>
              </template>
            </vs-td>
            <vs-td>
              <span v-if="t.type === 'investor'">IID: {{t.profileId}}</span>
              <span v-else>CID: {{t.profileId}}</span>
            </vs-td>
            <td>
              <span
                class="label"
                :class="{'label-success': t.status === 'done', 'label-danger': t.status !== 'done'}">
                {{t.status|translateStatus}}
              </span>
            </td>
            <vs-td>{{ t.operation_date }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "IrregularTransactions",
  data: () => ({
    transactions: [],
    startDate: null,
    endDate: null,
    queryString: null,
    filters: []
  }),
  filters: {
    translateStatus(status) {
      switch (status) {
        case "refund": return "Devuelto";
        case "done": return "Completado";
        case "issuer_different": return "Declinado";
      }
    }
  },
  async mounted() {
    this.startDate = moment().subtract(7, 'days').format("Y-MM-DD");
    this.endDate = moment().format("Y-MM-DD");

    await this.findTransactions()
  },
  methods: {
    async findTransactions() {
      this.$vs.loading();
      try {
        const {data} = await axios.post(`/api/treasury/irregular-trx`, {
          query: this.queryString,
          start_date: this.startDate,
          end_date: this.endDate
        })

        this.transactions = data;
      } finally {
        this.$vs.loading.close();
      }
    }
  }
}
</script>

<style scoped>

</style>
